import { useState } from 'react';

import { Input } from '@/components/ui/catalyst/input';
import { ArtifactFact } from '@/services/types/artifact-digest-types';

import { FactCard } from '../cards';

interface FactsSectionProps {
  facts: ArtifactFact[];
}

export const FactsSection = ({ facts }: FactsSectionProps) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!facts || facts.length === 0) {
    return <p className="text-sm text-muted-foreground">No facts available</p>;
  }

  // Filter facts based on search term
  const filteredFacts = facts.filter(
    (fact) =>
      fact.statement.toLowerCase().includes(searchTerm.toLowerCase()) ||
      fact.attribution.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (fact.supporting_excerpts &&
        fact.supporting_excerpts.some((excerpt) =>
          excerpt.toLowerCase().includes(searchTerm.toLowerCase()),
        )),
  );

  return (
    <div>
      <Input
        placeholder="Search facts..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="mb-2"
      />

      {filteredFacts.length === 0 ? (
        <p className="text-sm text-muted-foreground">No matching facts</p>
      ) : (
        <div className="divide-y divide-zinc-100 dark:divide-zinc-800">
          {filteredFacts.map((fact) => (
            <FactCard key={fact.id} fact={fact} />
          ))}
        </div>
      )}
    </div>
  );
};
